export const normalizeVehiclePlate = (raw: string): string => raw.toUpperCase().replace(/[^A-Z0-9-]/g, '')
